import { isArabicString, isDefinedString } from "et3-type-guards";

import {
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH
} from "../constants/input-entries-constants";

const PASSWORD_UPPERCASE_PATTERN = /[A-Z]/;
const PASSWORD_LOWERCASE_PATTERN = /[a-z]/;
const PASSWORD_DIGIT_PATTERN = /\d/;
const PASSWORD_SYMBOL_PATTERN = /[^A-Za-z0-9]/;
const PASSWORD_WHITESPACE_PATTERN = /\s/;

export type TPasswordRuleChecks = {
  hasValidLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasDigit: boolean;
  hasSymbol: boolean;
  hasNoArabic: boolean;
  hasNoWhitespace: boolean;
};

export const getAdminPasswordRuleChecks = (
  password: string
): TPasswordRuleChecks => {
  const isFilled = isDefinedString(password);

  return {
    hasValidLength:
      isFilled &&
      password.length >= PASSWORD_MIN_LENGTH &&
      password.length <= PASSWORD_MAX_LENGTH,
    hasUppercase: isFilled && PASSWORD_UPPERCASE_PATTERN.test(password),
    hasLowercase: isFilled && PASSWORD_LOWERCASE_PATTERN.test(password),
    hasDigit: isFilled && PASSWORD_DIGIT_PATTERN.test(password),
    hasSymbol: isFilled && PASSWORD_SYMBOL_PATTERN.test(password),
    hasNoArabic: isFilled && !isArabicString(password),
    hasNoWhitespace: isFilled && !PASSWORD_WHITESPACE_PATTERN.test(password)
  };
};

export const isStrongAdminPassword = (password: string) =>
  Object.values(getAdminPasswordRuleChecks(password)).every((isMet) => isMet);
